import { useEffect, useState } from "react";
import http from "../utils/http";

export default function useNeedReturnCount({ market }) {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!market) {
      setTotal(0);
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const res = await http.get("/postings", {
          params: {
            "filters[market][$eq]": market,
            "filters[state][$eq]": "cancelled",
            "filters[return_status][$eq]": "need_return",
            "pagination[page]": 1,
            "pagination[pageSize]": 1,
          },
        });

        if (!cancelled) {
          setTotal(res.data?.meta?.pagination?.total ?? 0);
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Ошибка загрузки счетчика need_return:", error);
          setTotal(0);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [market]);

  return total;
}
